import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IOperacionComision } from "../model";

export default class OperacionComisionService extends ServiceBase {
  get = (data:{ id?: number }) : Promise<IResponse<IOperacionComision>> => 
    this.GetFetch<IResponse<IOperacionComision>>('entity/operacioncomision', data);

  find = (data:{ 
    pageIndex?: number, pageSize?: number, sort?: string, 
    creafechaDesde?: string, creafechaHasta?: string, 
    codigo?: string, idcotizador?: number, idcliente?: number, acceso?: string, 
    fechadesdeDesde?: string, fechadesdeHasta?: string, fechahastaDesde?: string, fechahastaHasta?: string, 
    email?: string, whatsapp?: string, codigodescuento?: string, idorigen?: number, iddestino?: number
  }) : Promise<IPaginatedResponse<IOperacionComision>> => 
    this.GetFetch<IPaginatedResponse<IOperacionComision>>('entity/operacioncomision/find', data);

  /*
  upsert = (data:ICotizacion) : Promise<IResponse<ICotizacion>> => 
    this.PostFetch<IResponse<ICotizacion>>('entity/cotizacion', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/cotizacion', data);
  */
}
